import { render, staticRenderFns } from "./Proximity.vue?vue&type=template&id=08ed4962&scoped=true&"
import script from "./Proximity.vue?vue&type=script&lang=js&"
export * from "./Proximity.vue?vue&type=script&lang=js&"
import style0 from "./Proximity.vue?vue&type=style&index=0&id=08ed4962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed4962",
  null
  
)

export default component.exports